<script setup>

import PartneroBranding from "../../../PartneroBranding.vue";
import EditableTextField from "../../../portal-editable-fields/EditableTextField.vue";
import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const email = computed({
    get() { return portalContentAndDesignStore.portalLayoutSettings.portal_dashboard_contact_info_email;},
    set(value) { portalContentAndDesignStore.portalLayoutSettings.portal_dashboard_contact_info_email = value;}
});

const phone = computed({
    get() { return portalContentAndDesignStore.portalLayoutSettings.portal_dashboard_contact_info_phone;},
    set(value) { portalContentAndDesignStore.portalLayoutSettings.portal_dashboard_contact_info_phone = value;}
});

const hasContactInfo = computed(() =>
    (email.value && email.value.trim() !== '') ||
    (phone.value && phone.value.trim() !== '')
);

// Determine program type for layout justification
const programType = computed(() => {
    return portalContentAndDesignStore.program?.program_type?.type || 
           portalContentAndDesignStore.program?.programType?.type || 
           'affiliate';
});

// Justification class based on program type
const justificationClass = computed(() => {
    // Referral portal: justify-between (language selector left, branding right)
    // Affiliate portal: justify-end (both on the right)
    return programType.value === 'refer_a_friend' ? 'justify-between' : 'justify-end';
});

</script>

<template>
    <div :class="[
        'grid grid-cols-1 gap-8',
        hasContactInfo ? 'sm:grid-cols-2' : '',
        portalContentAndDesignStore.portalLayoutSettings.portal_layout !== 'none' ? 'pt-10' : 'pt-16',
    ]"
    >
        <div v-if="hasContactInfo"
            class="flex items-center justify-start"
        >
            <div class="text-sm space-x-1">
                <editable-text-field
                    :class="['text-opacity-60', portalContentAndDesignStore.getTextColorClass]"
                    container-classes="inline-block"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_need_help_text"
                    text-type="span"
                />
                <editable-text-field
                    v-if="email && email.trim() !== ''"
                    v-model="email"
                    text-type="a"
                    :href="`mailto:${email}`"
                    container-classes="inline-block"
                    :class="[
                    'text-opacity-75 hover:underline',
                    portalContentAndDesignStore.getTextColorClass
                ]"
                />

                <template v-if="phone && phone.trim() !== ''">
                    <editable-text-field v-if="email && email.trim() !== ''"
                        :class="['text-opacity-60', portalContentAndDesignStore.getTextColorClass]"
                        container-classes="inline-block"
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_or"
                        text-type="span"
                    />
                    <editable-text-field
                        v-model="phone"
                        text-type="a"
                        :href="`tel:${phone}`"
                        container-classes="inline-block"
                        :class="[
                            'text-opacity-75 hover:underline',
                            portalContentAndDesignStore.getTextColorClass
                        ]"
                    />
                </template>
            </div>
        </div>

        <div :class="['flex items-center gap-4 w-full', justificationClass]">
            <!-- Language Selector -->
            <div v-if="portalContentAndDesignStore.multilanguageEnabled">
                <language-selector></language-selector>
            </div>
            <!-- Empty div placeholder for justify-between layout (referral portal only) -->
            <div v-else-if="programType.value === 'refer_a_friend'"></div>
            
            <!-- Partnero Branding -->
            <partnero-branding
                :portal-general-partnero-branding-enabled="portalContentAndDesignStore.partneroBrandingSettings?.enabled ?? false"
                :unique-key-link="portalContentAndDesignStore.partneroBrandingSettings?.unique_key_link ?? ''"
                :container-classes="''"
            />
        </div>
    </div>
</template>

